import { render, staticRenderFns } from "./PracticeLessonPrice.vue?vue&type=template&id=dfca75de&scoped=true"
import script from "./PracticeLessonPrice.vue?vue&type=script&lang=js"
export * from "./PracticeLessonPrice.vue?vue&type=script&lang=js"
import style0 from "./PracticeLessonPrice.vue?vue&type=style&index=0&id=dfca75de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfca75de",
  null
  
)

export default component.exports